module.exports = __webpack_public_path__ + "img/file-pdf.9be0b077.svg";